/**
 * Constants used for actions for practice-store.js
 */

export const SET_CURRENT_TOPIC = "SET_CURRENT_TOPIC" as const;
export const CLEAR_RECOMMENDATION = "CLEAR_RECOMMENDATION" as const;
export const LOAD_USER_INFO = "LOAD_USER_INFO" as const;
export const UPDATE_FPM_MASTERY = "UPDATE_FPM_MASTERY" as const;
export const UPDATE_FPM_MASTERY_COMPLETE =
    "UPDATE_FPM_MASTERY_COMPLETE" as const;
export const UPDATE_PROGRESS = "UPDATE_PROGRESS" as const;
export const UPDATE_RECOMMENDATIONS = "UPDATE_RECOMMENDATIONS" as const;
export const UPDATE_STATUS = "UPDATE_STATUS" as const;
export const UPDATE_BEST_SCORE = "UPDATE_BEST_SCORE" as const;
export const UPDATE_LATEST_SCORE = "UPDATE_LATEST_SCORE" as const;
export const UPDATE_QUIZ_SCORE = "UPDATE_QUIZ_SCORE" as const;
export const UPDATE_TASK_STATUS = "UPDATE_TASK_STATUS" as const;
export const UPDATE_LAST_SECOND_WATCHED = "UPDATE_LAST_SECOND_WATCHED" as const;
